/**
 * Props for ratings slot (including a subset of Course API type)
 *
 * @remarks
 *
 * @see `browse/types/course` for `course`
 */

/**
 * Converts Course API fields to `CourseCard` ratings props.
 *
 * @remarks
 *
 * @see `browse/types/course`
 */
export const ratingsPropsFrom = _ref => {
  let {
    course,
    numReviewsText
  } = _ref;
  return {
    rating: course.rating,
    reviewsCount: course.num_reviews,
    reviewsCountText: numReviewsText
  };
};
//# sourceMappingURL=ratings.js.map